<mat-form-field class="form-field" [appearance]="appearance">
    
    <mat-label>
        {{label}}
    </mat-label>

    <mat-select [formControl]="formControl">
        <mat-option *ngFor="let s of status" [value]="s.offerstateid">
            {{s.offerstatename}}
        </mat-option>
    </mat-select>
    
</mat-form-field>
